import * as actionTypes from "./actionTypes";
import { GlobalAppState, GlobalAppStateAction } from "./GlobalAppState";

const initialState: GlobalAppState = {
  appState: { bedarfeCount: 0, hasTeamInvitation: false },
};

const reducer = (
  state: GlobalAppState = initialState,
  action: GlobalAppStateAction
): GlobalAppState => {
  switch (action.type) {
    case actionTypes.SET_APPSTATE:
      return {
        ...state,
        appState: action.appState,
      };
  }
  return state;
};

export default reducer;
